import { type ComponentProps, forwardRef } from 'react';

import { type CSSProperties, theme } from '../../style';

import { View } from './View';

type CardProps = ComponentProps<typeof View> & {
  childWrapperStyles?: CSSProperties;
};

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ children, childWrapperStyles, ...props }, ref) => {
    return (
      <View
        {...props}
        ref={ref}
        style={{
          marginTop: 15,
          marginLeft: 5,
          marginRight: 5,
          borderRadius: 6,
          backgroundColor: theme.cardBackground,
          borderColor: theme.cardBorder,
          boxShadow: '0 1px 2px #9594A8',
          ...props.style,
        }}
      >
        <View
          style={{
            borderRadius: 6,
            overflow: 'hidden',
            ...childWrapperStyles,
          }}
        >
          {children}
        </View>
      </View>
    );
  },
);

Card.displayName = 'Card';
